module.exports = __webpack_public_path__ + "img/chalice-red.418f691f.svg";